import React from 'react';

const Services = () => {
  const services = [
    {
      id: 1,
      icon: '🏠',
      title: 'Búsqueda de Vivienda',
      description: 'Encuentra tu hogar perfecto en Quito y Los Valles con asistencia personalizada, análisis de mercado y negociación experta.',
      features: ['Búsqueda de Propiedades', 'Análisis de Mercado', 'Negociación', 'Apoyo en Cierre']
    },
    {
      id: 2,
      icon: '💰',
      title: 'Comercialización de Vivienda',
      description: 'Potencia el valor de tu propiedad con asesoría de alto nivel y marketing profesional.',
      features: ['Avalúo de Propiedad', 'Estrategia de Marketing', 'Asesoría en Presentación Inmobiliaria', 'Gestión de Ofertas']
    },
    {
      id: 3,
      icon: '🏞️',
      title: 'Terrenos y Lotes',
      description: 'Asesoría especializada en compra y venta de terrenos para construcción o inversión en las mejores zonas de Quito y Los Valles.',
      features: ['Avalúo de Terrenos', 'Verificación Legal', 'Asesoría en Zonificación', 'Potencial de Inversión']
    },
    {
      id: 4,
      icon: '🏢',
      title: 'Bienes Raíces Comerciales',
      description: 'Navega propiedades comerciales con experiencia en espacios comerciales y de oficina.',
      features: ['Selección de Ubicación', 'Negociación de Arrendamiento', 'Investigación de Mercado']
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Lo Que Ofrezco</span>
          <h2 className="section-title">Servicios Inmobiliarios Integrales</h2>
          <p className="section-subtitle">
            Si deseas comprar, vender o alquilar casas, departamentos o terrenos, proporciono soluciones personalizadas para todas tus necesidades inmobiliarias en Quito y Los Valles
          </p>
        </div>

        <div className="services-grid">
          {services.map(service => (
            <div key={service.id} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, index) => (
                  <li key={index}>
                    <span className="check">✓</span>{` ${feature}`}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <p className="cta-text">¿Necesitas asesoría?</p>
          <a href="https://wa.me/593995410584" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Obtén Consulta Gratuita</a>
        </div>
      </div>
    </section>
  );
};

export default Services;
